import React from 'react';
import { blindBuriedHole } from 'pu-data/SelectOptions';
import { blindBuriedHole as tooltip } from 'pu-data/Tooltips';
import CheckboxComponent from './CheckboxComponent';

const BlindBuriedHole = (props) => {
  const name = 'blind_buried_hole';
  return (
    <CheckboxComponent
      name={name}
      inputId={name}
      label={props.label}
      tooltip={props.tooltip}
      checked={props.parameters[name] === '1'}
      onChange={(e) => props.onChangeParameter(name, e.target.checked ? '1' : '0')} />
  );
};

BlindBuriedHole.defaultProps = {
  options: blindBuriedHole,
  label: 'Blind and Buried Hole',
  tooltip,
};

export default BlindBuriedHole;
